<div class="card-body">
  <app-ag-grid-table
    #agGridRef
    [rowData]="rowData"
    [columnDefs]="colDefs"
    [parentContext]="this"
    [paginationPageSize]="paginationPageSize"
    (gridReady)="onGridReady($event)"
    (reloadTable)="reload($event)"
  ></app-ag-grid-table>

  <div class="grid-disclaimer mt-2">
    <small>
      Note: For more billing details please contact customer care.
    </small>
  </div>
</div>

<!-- Visible Popup -->
<div *ngIf="popupVisible" class="popup-backdrop">
  <div class="popup-content">
    <h2 class="popup-heading">Billing History -</h2>

    <div class="popup-row">
      <span class="popup-label">Plan Name -</span>
      <span class="popup-value">{{
        popupData?.subBundle?.bundle_name +
          " " +
          popupData?.subPack?.pack_name || "N/A"
      }}</span>
    </div>

    <div class="popup-row">
      <span class="popup-label">Category Name -</span>
      <span class="popup-value">{{
        popupData?.category?.category_name || "N/A"
      }}</span>
    </div>

    <div class="popup-row">
      <span class="popup-label">Billing Type -</span>
      <span class="popup-value">
        {{
          popupData?.is_addon == 1
            ? "Additional Category"
            : popupData?.is_addon == 0
            ? "Main Plan"
            : "N/A"
        }}
      </span>
    </div>

    <div class="popup-row">
      <span class="popup-label">Subscription Type -</span>
      <span class="popup-value">{{ popupData?.sub_type || "N/A" }}</span>
    </div>

    <div class="popup-row">
      <span class="popup-label">Amount -</span>
      <span class="popup-value">
        {{
          popupData?.amount && popupData?.currency
            ? popupData.amount + " " + popupData.currency
            : "N/A"
        }}</span
      >
    </div>

    <div class="popup-row">
      <span class="popup-label">Payment Mode -</span>
      <span class="popup-value">{{
        popupData?.paymentGateway?.payment_gateway || "N/A"
      }}</span>
    </div>
    <div class="popup-row">
      <span class="popup-label">Status -</span>
      <span
        [ngSwitch]="popupData?.subStatus?.sub_status_id"
        [style.color]="
          [1, 15].includes(popupData?.subStatus?.sub_status_id)
            ? 'green'
            : [9, 4].includes(popupData?.subStatus?.sub_status_id)
            ? 'red'
            : 'black'
        "
      >
        <ng-container *ngSwitchCase="1">✅ Active</ng-container>
        <ng-container *ngSwitchCase="15">✅ Active</ng-container>

        <ng-container *ngSwitchCase="9">❌ Failed</ng-container>
        <ng-container *ngSwitchCase="4">❌ Failed</ng-container>

        <ng-container *ngFor="let id of [0, 2, 14, 8, 19]">
          <ng-container *ngSwitchCase="id">In Progress</ng-container>
        </ng-container>

        <ng-container *ngSwitchCase="20">Deactivated</ng-container>
        <ng-container *ngSwitchDefault>Unknown</ng-container>
      </span>
    </div>

    <div class="popup-row">
      <span class="popup-label">Billed On -</span>
      <span class="popup-value">
        {{
          popupData?.last_billing_date && popupData.last_billing_date !== "N/A"
            ? (popupData.last_billing_date | date : "dd-MMM-yyyy")
            : "N/A"
        }}
      </span>
    </div>

    <div class="popup-row">
      <span class="popup-label">Transaction Number -</span>
      <span class="popup-value">{{ popupData?.billing_number }}</span>
    </div>

    <div class="popup-row">
      <span class="popup-label">Transaction ID -</span>
      <span class="popup-value">{{ popupData?.client_trans_id || "N/A" }}</span>
    </div>

    <div class="popup-row">
      <span class="popup-label">Subscribed Via -</span>
      <span class="popup-value">{{
        popupData?.subChannel?.channel_name || "Web / App / USSD / SMS"
      }}</span>
    </div>

    <button
      class="popup-bottom-close button_class"
      (click)="closeVisualPopup()"
    >
      Okay
    </button>
  </div>
</div>
